import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getSelectedFactorCategoryName } from "./data"
import { getFactorSensitivityType } from "."

const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate
const getPositionSetName = (_, props) => props.positionSetName
const getViewType = (_, props) => props.viewType

export const getScreenName = createSelector(
  [getFactorSensitivityType],
  (factorSensitivityType) => `${capitalize(factorSensitivityType)} Factor Sensitivity`,
)

export const getFileName = createSelector(
  [getPositionSetName, getSelectedFactorCategoryName, getViewType, getScreenName, getStartDate, getEndDate],
  (positionSetName, categoryName, viewType, screenName, startDate, endDate) => `${positionSetName} ${categoryName} ${capitalize(viewType)} ${screenName} ${startDate} - ${endDate}`,
)
